/* Lumora theme.js */
(function(){
  'use strict';

  // FAQ accordion
  document.addEventListener('click', function(e){
    var q = e.target.closest('.faq__q');
    if(q){ q.parentElement.classList.toggle('is-open'); }

    // Variant selector
    var v = e.target.closest('.variant');
    if(v){
      var group = v.parentElement;
      group.querySelectorAll('.variant').forEach(function(el){ el.classList.remove('is-selected'); });
      v.classList.add('is-selected');
    }

    // Payment option toggle
    var p = e.target.closest('.payopt__opt');
    if(p){
      var pgroup = p.parentElement;
      pgroup.querySelectorAll('.payopt__opt').forEach(function(el){ el.classList.remove('is-selected'); });
      p.classList.add('is-selected');
    }

    // Mobile nav
    var mt = e.target.closest('[data-mobile-toggle]');
    if(mt){
      var menu = document.querySelector('[data-mobile-menu]');
      if(menu) menu.classList.toggle('is-open');
    }
  });

  // Countdown timer
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var end = new Date(Date.now() + (parseInt(el.dataset.countdown,10) || 24*3600) * 1000);
    function tick(){
      var diff = Math.max(0, Math.floor((end - new Date())/1000));
      var h = String(Math.floor(diff/3600)).padStart(2,'0');
      var m = String(Math.floor((diff%3600)/60)).padStart(2,'0');
      var s = String(diff%60).padStart(2,'0');
      el.textContent = h + ' : ' + m + ' : ' + s;
    }
    tick(); setInterval(tick, 1000);
  });

  // Duplicate marquee content for seamless scroll
  document.querySelectorAll('.marquee-track,.tmarquee__track,.img-marquee__track').forEach(function(t){
    t.innerHTML = t.innerHTML + t.innerHTML;
  });

  // Smooth scroll for #anchors
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var href = a.getAttribute('href');
      if(href.length > 1){
        var target = document.querySelector(href);
        if(target){ e.preventDefault(); target.scrollIntoView({behavior:'smooth', block:'start'}); }
      }
    });
  });
})();
